import React, { useEffect, useState } from 'react'
import MainPage from '../../../composents/MainPage'
import Swal from 'sweetalert2'
import { ApiGeneric } from '../../../api'

const title = 'Task'
const headers = {
  icon: 'feather icon-list',
  title,
  description: 'manage all task information',
}

const api = new ApiGeneric()

function TaskPage() {
  const [tasks, setTasks] = useState([])
  const onNewClick = async (e) => {
    e.preventDefault()

    const task = 'task'
    const { value: content } = await Swal.fire({
      title: 'Create new task',
      input: 'text',
      inputPlaceholder: `Enter your ${task}`,
      showCancelButton: true,
      confirmButtonText: 'Save',
    })

    if (content) {
      await api.onSend('/tasks', {
        data: {
          content,
        },
        method: 'POST',
      })

      onGetTask()
    }
  }

  const onCheckClick = async (e, item, key) => {
    const newTask = [...tasks]
    newTask[key].completed = e.target.checked
    setTasks(newTask)

    await api.onSend('/tasks/' + item.id, {
      data: {
        content: item.content,
        completed: e.target.checked,
      },
      method: 'PUT',
    })
  }

  const onDelete = async (e, item, key) => {
    const { value } = await Swal.fire({
      title: 'Are you sure?',
      text: "you want to delete this entity, you can't go back",
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: 'Yes, delete it!',
      closeOnConfirm: false,
    })
    if (value) {
      const newTask = [...tasks]
      delete newTask[key]
      setTasks(newTask)

      await api.onSend('/tasks/' + item.id, {
        method: 'DELETE',
      })
    }
  }

  const onGetTask = async () => {
    const response = await api.onSend('/tasks')
    setTasks(response?.docs)
  }

  useEffect(() => {
    onGetTask()
  }, [])

  return (
    <MainPage headers={headers} show_search>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5>Task</h5>
              <div className="card-header-right" style={{ right: '20PX' }}>
                <a
                  href="#"
                  onClick={onNewClick}
                  className="btn waves-effect waves-light btn-primary"
                >
                  <i className="feather icon-plus"></i>
                  New entity
                </a>
              </div>
            </div>
            <div className="card-block">
              <section className="task-panel tasks-widget">
                <div className="panel-body">
                  <div className="task-content">
                    {tasks.map((task, index) => {
                      const classCompleted = task.completed ? 'done-task' : ''
                      return (
                        <div className="to-do-label">
                          <div className="checkbox-fade fade-in-primary">
                            <label className={'form-label check-task ' + classCompleted}>
                              <input
                                type="checkbox"
                                value=""
                                onClick={(e) => onCheckClick(e, task, index)}
                                checked={task.completed}
                              />
                              <span className="cr">
                                <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                              </span>
                              <span className="task-title-sp">{task.content}</span>
                              <span
                                className="float-end hidden-phone"
                                onClick={(e) => onDelete(e, task, index)}
                              >
                                <i className="icofont icofont-ui-delete delete_todo"></i>
                              </span>
                            </label>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </MainPage>
  )
}

export default TaskPage
